import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">{t('pageNotFound')}</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">{t('pageNotFoundDesc')}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-line" />
          {t('backToHome')}
        </Link>
      </div>
    </div>
  );
}